var SECONDARY_FONTS = {
  headerFont: "'quadrant-text', Georgia, TimesNewRoman, 'Times New Roman', Times, Baskerville, serif",
  baseFont: "\"GreyLLWeb-Regular\", 'Century Gothic', CenturyGothic, AppleGothic, Verdana, sans-serif",
  monoFont: "'quadrant-text-mono', Monaco, monospace"
};

export { SECONDARY_FONTS as default };
